
export const file2Base64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result?.toString() || '')
    reader.onerror = error => reject(error)
  })
}

export const getFileInBase64 = async (
  fileList: FileList | null
): Promise<string | undefined> => {
  if (fileList) {
    const file = fileList[0]

    return file2Base64(file)
      .then((base64: any) => {
        return base64.toString().replace(/^data:(.*,)?/, '')
      })
      .catch(() => {
        return undefined
      })
  }

  return undefined
}
